module.exports = __webpack_public_path__ + "img/green_silhouette.a952d551.png";